import React from 'react';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router';
import { connect } from 'react-redux';
import classNames from 'classnames';

import ContextPagination from 'rebook/apps/base/components/ContextPagination';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import fetchQuery from 'rebook/apps/utils/fetchQuery';
import { URLS } from 'rebook/apps/base/constants';
import PaymentListEmpty from 'rebook/apps/users/components/PaymentListEmpty';

import PaymentListPaymentData from './PaymentListPaymentData';
import styles from './style.scss';


class PaymentListView extends React.Component {
  constructor(props) {
    super(props);
    this.paginateBy = 10;

    this.state = {
      payments: null,
      pageNumber: 1,
      lastPageNumber: 1,
    };
  }

  componentWillMount() {
    this.props.SeoActions.setData({
      title: 'Настройки вашего профиля и история покупок',
    });
  }

  componentDidMount() {
    if (!this.props.user) {
      return;
    }
    this.changePage(1);
  }

  changePage(pageNumber = 1) {
    const offset = pageNumber > 1 ? (pageNumber - 1) * this.paginateBy : 0;

    fetchQuery(`/api/payments/?limit=${this.paginateBy}&offset=${offset}`)
    // fetchQuery(`/api/payments/`)
      .then(({ data }) => {
        window.scrollTo(0, 0);
        const lastPageNumber = Math.ceil(data.meta.total_count / this.paginateBy);
        this.setState({
          payments: data.objects,
          pageNumber,
          lastPageNumber,
        });
      });
  }

  render() {
    const { user } = this.props;
    const { payments } = this.state;

    if (!user) {
      return <Redirect to={URLS.authForm} />;
    }

    return (
      <div className={classNames(
        'backgroundContainer', 'themeGrey',
        payments && payments.length === 0 && styles.emptyPaymentList,
      )}>
        <div className={styles.wrapper}>
          <div className="title-1">История покупок</div>
          {!payments && (
            <React.Fragment>
              <PaymentListEmpty />
              <PaymentListEmpty />
              <PaymentListEmpty />
            </React.Fragment>
          )}
          {payments && payments.length > 0 && (
            <div className="jest-payment-list">
              <PaymentListPaymentData payment={payments} />
              <ContextPagination
                extraClassName="jest-payment-list-pagination"
                onPageChange={(newPageNumber) => this.changePage(newPageNumber)}
                currentPage={this.state.pageNumber}
                lastPage={this.state.lastPageNumber} />
            </div>
          )}
          {payments && payments.length === 0 && (
            <div className="jest-payment-list">
              <div>
                <div className="title-2">Здесь будут ваши платежи</div>
              </div>
              <ContextPagination
                extraClassName="jest-payment-list-pagination"
                onPageChange={(newPageNumber) => this.changePage(newPageNumber)}
                currentPage={this.state.pageNumber}
                lastPage={this.state.lastPageNumber} />
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    SeoActions: bindActionCreators(SeoActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentListView);
